// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_yH7","label":"styles_label__2h1EI"};